<template>
  <div :bordered='false'>
    <div class='table-page-search-wrapper'>
      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='24'>
          <a-col :md='8' :sm='12'>
            <a-form-item :label="$t(I18N_KEY + 'loanDate')">
              <a-range-picker
                v-model='queryParam.selectDate'
                format='YYYY-MM-DD' />
            </a-form-item>
          </a-col>
          <a-col :md='8' :sm='12'>
            <a-form-item :label="$t(I18N_KEY + 'repayDate')">
              <a-range-picker
                v-model='queryParam.repayDate'
                format='YYYY-MM-DD' />
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
                  <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
                    <a-button type='primary' @click='searchQuery' icon='search'>{{ $t('search') }}</a-button>
                    <a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>{{ $t('reset')
                      }}</a-button>
                      <a-button type='primary' @click="downLoadData()" icon='download'
                              style='margin-left: 8px'>{{ $t('exportFile')
                      }}</a-button>
                  </span>
          </a-col>
        </a-row>
      </a-form>

      <!-- 汇总数据表格 -->
      <a-card title="汇总数据" size="small" style="margin-bottom: 16px;">
        <a-table
          :columns="summaryColumns"
          :dataSource="summaryData"
          :pagination="false"
          :showHeader="true"
          size="small"
          bordered>
        </a-table>
      </a-card>

      <a-table
        ref='table'
        rowKey='id'
        size='middle'
        :columns='columns'
        :dataSource='dataSource'
        :pagination='false'
        :loading='loading'
        bordered
        @change='handleTableChange'>
      </a-table>
      <div style='margin-top: 15px; text-align: right;'>
        <v-pagination
          v-if='total'
          :page-num='form.pageNum'
          :page-size='form.pageSize'
          :total='total'
          @change='handleTableChange' />
      </div>
      <pending-modal ref='modalForm'></pending-modal>
    </div>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getOrderContractContract, getOrderContractContractSum } from '@/webpublicapi/order'
import Dict from '../modules/Dict'
import PendingModal from '../order/modules/PendingModal'
import vModal from '../modules/Modal'
import OrderDetail from '../order/OrderDetail'
import moment from 'moment'
import exportFile from '@/api/exportFile'

const I18N_KEY = 'order.'

export default {
  name: 'PendingOrderlist',
  components: {
    vModal,
    OrderDetail,
    Dict,
    PendingModal
  },
  data() {
    return {
      I18N_KEY,
      toggleSearchStatus: false,
      visible: false,
      orderId: undefined,
      custInfoId: undefined,
      form: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      dataSource: [],
      sum:{},
      // 查询条件
      queryParam: {
        'selectDate': [moment().startOf('day'), moment().startOf('day')],
        'repayDate': [moment().startOf('day'), moment().startOf('day')]
      },
      loading: false,
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    summaryColumns() {
      return [
        {
          title: this.$t(I18N_KEY + 'repayCount'),
          dataIndex: 'repayCount',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY + 'repayUserCount'),
          dataIndex: 'repayUserCount',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY + 'repaySumAmout'),
          dataIndex: 'repaySumAmout',
          align: 'center'
        }
      ]
    },
    summaryData() {
      return [
        {
          repayCount: this.formatNumber(this.sum.repayCount),
          repayUserCount: this.formatNumber(this.sum.repayUserCount),
          repaySumAmout: this.formatNumber(this.sum.loanamount)
        }
      ]
    },
    columns() {
      return [
        {
          title: this.$t(I18N_KEY + 'startingTime'),
          align: 'left',
          dataIndex: 'startcontract'
        },
        {
          title: this.$t(I18N_KEY + 'orderNo'),
          align: 'left',
          dataIndex: 'transno'
        },
        // {
        //   title: this.$t(I18N_KEY + 'card'),
        //   align: 'left',
        //   dataIndex: 'curp'
        // },
        {
          title: this.$t('customer.firstName'),
          align: 'left',
          dataIndex: 'customer_firstname'
        },
        {
          title: this.$t(I18N_KEY + 'applyAmt'),
          align: 'left',
          dataIndex: 'loanamount'
        },
        {
          title: this.$t(I18N_KEY + 'loanDuration'),
          align: 'left',
          dataIndex: 'loanDuration'
        },
        // {
        //   title: this.$t(I18N_KEY + 'currentPeriod'),
        //   align: 'left',
        //   dataIndex: 'currentPeriod',
        //   customRender: (text) => 1
        // },
        // {
        //   title: this.$t(I18N_KEY + 'remainingPrincipal'),
        //   align: 'left',
        //   dataIndex: 'remainingPrincipal',
        //   customRender: (text) => 0.00
        // },
        // {
        //   title: this.$t(I18N_KEY + 'overdueDays'),
        //   align: 'left',
        //   dataIndex: 'overdueDays'
        // },
        // {
        //   title: this.$t(I18N_KEY + 'unpaidPrincipal'),
        //   align: 'left',
        //   dataIndex: 'loanamount'
        // },
        {
          title: this.$t(I18N_KEY + 'interest'),
          align: 'left',
          dataIndex: 'interest'
        },
        {
          title: this.$t(I18N_KEY + 'lateFee'),
          align: 'left',
          dataIndex: 'lateFee'
        },
        // {
        //   title: this.$t(I18N_KEY + 'eachIssueAmount'),
        //   align: 'left',
        //   dataIndex: 'eachIssueAmount'
        // },
        {
          title: this.$t(I18N_KEY + 'handlingFee'),
          align: 'left',
          dataIndex: 'handlingFee'
        },
        {
          title: this.$t(I18N_KEY + 'recoveryAmount'),
          align: 'left',
          dataIndex: 'recoveryAmount'
        },
        // {
        //   title: this.$t(I18N_KEY + 'totalRemainingDebt'),
        //   align: 'left',
        //   dataIndex: 'totalpayment'
        // }
      ]
    }
  },
  created() {
    this.loadData(1)
  },
  methods: {
    downLoadData() {
      var params = this.getQueryParams()// 查询条件
      console.log('下载参数',params)
      const file = {
        fileUrl: '/api/web/webpublic/orderContract/contractExcel?startDate='
          + params.startDate + '&endDate=' + params.endDate + '&type=3' 
          + '&repayStartDate=' + params.repayStartDate + '&repayEndDate=' + params.repayEndDate,
        fileName:   "ContractRepaymentList_" + params.startDate  + params.endDate +'.xlsx',
      }
      this.loading = true;
      exportFile(file).catch(e => {
        this.$message.error(e.message);
      }).finally(() => {
        this.loading = false;
      })
    },
    formatNumber(value) {
      if (value === undefined || value === null) return '0'
      const num = Number(value)
      // 使用更严格的整数判断
      if (Number.isInteger(num) || num.toString().split('.')[1] === '0') {
        return num.toLocaleString('en-US')
      } else {
        return num.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })
      }
    },
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus
    },
    searchQuery() {
      this.loadData(1)
    },
    transformStringToLow(str) {
      return str && str.toLocaleLowerCase()
    },
    loadData(arg) {
      // 加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.form.pageNum = 1
      }
      this.loading = true
      var params = this.getQueryParams()// 查询条件
      params.type = 3
      getOrderContractContract(params).then((res) => {
        if (res.code === 1000) {
          this.total = res.data.total
          this.dataSource = res.data.list
          if (this.dataSource != null && this.dataSource.length > 0) {
            this.dataSource.forEach(item => {
              item.handlingFee = 0;
            })
          }
        } else {
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
      getOrderContractContractSum(params).then((res) => {
        if (res.code === 1000) {
          this.sum = res.data
        } else {
          this.sum = {}
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    getQueryParams() {
      var selectDate  = this.queryParam.selectDate
      var repayDate  = this.queryParam.repayDate
      console.log("params"+selectDate)
      var param = Object.assign({}, this.queryParam)
      param.pageNum = this.form.pageNum
      param.pageSize = this.form.pageSize
      param.startDate =  selectDate && this.transformTime(selectDate[0])
      param.endDate = selectDate && this.transformTime(selectDate[1])
      param.repayStartDate =  repayDate && this.transformTime(repayDate[0])
      param.repayEndDate = repayDate && this.transformTime(repayDate[1])
      delete param.selectDate;
      delete param.repayDate;
      return filterObj(param)
    },
    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.loadData()
    },
    // 重置字典类型搜索框的内容
    searchReset() {
      var that = this
      that.queryParam.selectDate = ''
      that.queryParam.startDate = ''
      that.queryParam.endDate = ''
      that.queryParam.repayDate = ''
      that.queryParam.repayStartDate = ''
      that.queryParam.repayEndDate = ''
    },
    changeModal(visible) {
      this.visible = visible
    },
    handleDetail(row) {
      this.orderId = row.id
      this.custInfoId = row.custInfoId
      this.changeModal(true)
    }
  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";
</style>
